import {fetchCPTList} from "../api/GetCPTList";

export const FiltersDataReducer = (state, action) => {

    //Currently only added the happy case of successful call to backend for simplicity. 
    //There might be other cases as well that requires loading etc.Will add them in subsequent phases.
    switch (action.type) {
        case 'UPDATE_FILTERS':  
                return action.filtersData

        case 'INITIALIZE_CYCLES':
            
            let cycles = [{"cycleId":"NONE","cycleName":"No Cycle"}];
            let cyclesFromParent = JSON.parse(action.cycleData.cycleList).filter(cycle => cycle.cycleId !== "AllCycles").map(cycle => {
                return {
                    ...cycle, displayableName : cycle.cycleId.replace('CYCLE_','')
                }
            }).sort((cycle1, cycle2) => (cycle1.cycleName > cycle2.cycleName) ? 1 : ((cycle2.cycleName > cycle1.cycleName) ? -1 : 0));
            cycles = cycles.concat(cyclesFromParent)
           
            return {
                ...state,
                cycles: cycles
            };

        case 'FETCH_CPT':
            fetchCPTList(action.data.dispatcher)
            return state

        case 'ASSIGN_LABEL':
            return {...state, CPTLabel: action.data.CPTLabel}

        case 'ASSIGN_FILTER_IDENTIFIER':
            return {...state, filterIdentifier: action.data.filterIdentifier}

        case 'RECEIVE_CPT':
            return {...state, CPT: action.data.CPT}
            
        default :
            return state
    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/FiltersDataReducer.js